<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';
import WhatsAppCampaignWizard from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/WhatsAppCampaignWizard.vue';

// The "new WhatsApp campaign" page (owner order 2026-09-25): a page of its
// own instead of a scrolling dialog; three steps and a phone preview.
const { t } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();

const backToList = () =>
  router.push({
    name: 'campaigns_whatsapp_index',
    params: { accountId: route.params.accountId },
  });

const handleSubmit = async (campaignDetails, callbacks = {}) => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);
    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });
    useAlert(t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.SUCCESS_MESSAGE'));
    backToList();
  } catch (error) {
    const message =
      error?.message || t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(message);
    callbacks.fail?.(message);
  }
};
</script>

<template>
  <section class="flex h-full w-full flex-col overflow-hidden bg-n-surface-1">
    <header
      class="sticky top-0 z-10 border-b border-n-weak bg-n-surface-1/95 px-4 backdrop-blur sm:px-6 lg:px-8"
    >
      <div class="mx-auto flex h-20 w-full max-w-6xl items-center gap-3">
        <button
          type="button"
          class="flex size-9 items-center justify-center rounded-lg text-n-slate-11 hover:bg-n-alpha-2"
          :aria-label="t('CAMPAIGN.WHATSAPP.WIZARD.NAV.BACK_TO_LIST')"
          @click="backToList"
        >
          <span
            class="i-lucide-arrow-right size-5 rtl:rotate-0 ltr:rotate-180"
          />
        </button>
        <span
          class="text-heading-1 font-semibold tracking-tight text-n-slate-12"
        >
          {{ t('CAMPAIGN.WHATSAPP.WIZARD.TITLE') }}
        </span>
      </div>
    </header>
    <main class="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-8">
      <div class="mx-auto w-full max-w-6xl py-6">
        <WhatsAppCampaignWizard @submit="handleSubmit" @cancel="backToList" />
      </div>
    </main>
  </section>
</template>
